import style from './index.module.css';
import React, { useState } from "react";
import { registerUser } from '../../services/AuthService';  

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    password: "",
    gender: "",
    fullname: "",
    file: null,
    email: "",  // Added email to form data
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.file) {
      setError("Şəkil əlavə etmək məcburidir.");
      return;
    }
    try {
      setError("");
      setSuccess("");
      await registerUser(formData);  
      setSuccess("Qeydiyyat uğurlu oldu!");
      alert("Qeydiyyat tamamlandı!"); // Qeydiyyat tamamlandıqdan sonra alert göstər
    } catch (err) {
      setError(err.response?.data?.message || "Xəta baş verdi!");
    }
  };

  return (
    <div>
      <div className={style.form}>
        <div className={style.img}>
          <a href=''><img src='https://new.axilthemes.com/demo/template/etrade/assets/images/logo/logo.png' alt="Logo" /></a>
        </div>
        <div className={style.sign}>
          <p>Not A Member? <a href='/Registr'>Sign Up Now</a></p>
        </div>
      </div>
      <div className={style.sign1}>
        <h2>I'm New Here</h2>
        <p>Enter your detail below</p>
      </div>
     
      <form onSubmit={handleSubmit}>
        <div className={style.group}>     
          <input type="text" required
            name="name"
            value={formData.name}
            onChange={handleChange} />
          <span className={style.highlight}></span>
          <span className={style.bar}></span>
          <label>User Name</label>
        </div>

        <div className={style.group}>      
          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <span className={style.highlight}></span>
          <span className={style.bar}></span>
          <label>Gender</label>
        </div>

        <div className={style.group}>      
          <input type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required />
          <span className={style.highlight}></span>
          <span className={style.bar}></span>
          <label>Password</label>
        </div>

        <div className={style.group}>      
          <input
            type="file"
            name="file"
            onChange={handleChange}
            required
          />
          <span className={style.highlight}></span>
          <span className={style.bar}></span>
          <label>Photo</label>
        </div>

        <div className={style.group}>      
          <input
            type="text"
            name="fullname"
            value={formData.fullname}
            onChange={handleChange}
            required
          />
          <span className={style.highlight}></span>
          <span className={style.bar}></span>
          <label>Full Name</label>
        </div>

        <div className={style.group}>      
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <span className={style.highlight}></span>
          <span className={style.bar}></span>
          <label>Email</label>
        </div>

        <div className={style.button}>
            <button type='submit'>Sign Up</button>
        </div>
      </form>

      {error && <p className={style.error}>{error}</p>}
      {success && <p className={style.success}>{success}</p>}
   
      <div className={style.form1}>
        <p>We Offer the Best Products</p>
      </div>
      <div className={style.hed}></div>
    </div>
  );
};

export default Register;
